/**
 * The app's motion language, in one place, so the drawer, the modal and the
 * phone sheet cannot drift apart.
 *
 * 340ms in on cubic-bezier(0.22, 1, 0.36, 1), 220ms out on ease-in, per the
 * house rule. Enter is slower than exit on purpose: a panel that takes as long
 * to leave as it took to arrive reads as sluggish rather than deliberate.
 *
 * `prefers-reduced-motion` is honoured twice, and both halves are needed. The
 * global CSS rule collapses transition and animation durations, which handles
 * what is seen. But a component that DEFERS its unmount behind a timeout has to
 * skip that wait too, or a caller sits waiting on an exit that never visually
 * happened. That is what `exitDelay` is for.
 */

export const ENTER_MS = 340;
export const EXIT_MS = 220;
export const EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';
export const EASE_IN = 'cubic-bezier(0.4, 0, 1, 1)';

/** Hover panels close on a delay so diagonal pointer travel survives the gap. */
export const HOVER_CLOSE_MS = 260;

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function exitDelay(ms: number = EXIT_MS): number {
  return prefersReducedMotion() ? 0 : ms;
}
